const SALT = 'switchbot-salt'
const ITERATIONS = 100000

// PBKDF2 で AES-256-GCM 鍵を導出する
// usages: ['encrypt'] or ['decrypt'] or ['encrypt','decrypt']
const deriveKey = async (usages) => {
    const enc = new TextEncoder()
    const rawKey = process.env.VUE_APP_SWITCHBOT_ENC_KEY
    
    const keyMaterial = await crypto.subtle.importKey(
        'raw', enc.encode(rawKey), 'PBKDF2', false, ['deriveKey']
    )
    return crypto.subtle.deriveKey(
        { name: 'PBKDF2', salt: enc.encode(SALT), iterations: ITERATIONS, hash: 'SHA-256' },
        keyMaterial,
        { name: 'AES-GCM', length: 256 },
        false, usages
    )
}

// 暗号化: "base64(IV):base64(暗号文+認証タグ)" 形式の文字列を返す
// Android 側は同じ PBKDF2(password, salt, 100000, SHA-256) → AES-256-GCM で復号可能
export const encrypt = async (plaintext) => {
    const key = await deriveKey(['encrypt'])
    const iv = crypto.getRandomValues(new Uint8Array(12))
    const enc = new TextEncoder()
    const cipherBuf = await crypto.subtle.encrypt({ name: 'AES-GCM', iv }, key, enc.encode(plaintext))
    const ivB64 = btoa(String.fromCharCode(...iv))
    const ctB64 = btoa(String.fromCharCode(...new Uint8Array(cipherBuf)))
    return `${ivB64}:${ctB64}`
}

// 復号化: "base64(IV):base64(暗号文+認証タグ)" 形式の文字列を受け取り平文を返す
export const decrypt = async (encryptedStr) => {
    const [ivB64, ctB64] = encryptedStr.split(':')
    const iv = Uint8Array.from(atob(ivB64), c => c.charCodeAt(0))
    const ciphertext = Uint8Array.from(atob(ctB64), c => c.charCodeAt(0))
    const key = await deriveKey(['decrypt'])
    const plainBuf = await crypto.subtle.decrypt({ name: 'AES-GCM', iv }, key, ciphertext)
    return new TextDecoder().decode(plainBuf)
}
